import { ContainerComponent, today, wrap } from 'AppReact';
import { Wrapper } from './wrappers';
import { SecondaryTextXs300, SecondaryTextSm, Empty, Popup } from 'atoms';
import { textEllipsis } from 'utils/ellipsis';
import Controller from './controller';
import { SolidButton } from 'molecules';
import { FlexCenterWrapper, GenericWrapper, Mr2, SpanWrapper, WhiteSpaceNoWrap, FlexCenterBetweenWrapper } from 'wrappers';
import internalState from './internalState';
import { DeliveredSVG, WaitingSVG, OrderedSVG } from 'components/icons';
import { formatDistance, differenceInSeconds } from 'date-fns';
import getIsMobile from 'components/atoms/utils/getIsMobile';

export const definition = {
  name: 'PartRow',
  controller: Controller,
  initialProps: ({ part }) => ({ part, isMobile: getIsMobile() }),
  props: internalState,
  elements: [
    {
      wrapper: wrap(FlexCenterBetweenWrapper, Wrapper),
      name: '__transparent__',
      elements: [
        {
          wrapper: FlexCenterWrapper,
          name: 'InfoWrapper',
          elements: [
            {
              component: wrap(Empty, Mr2),
              name: 'Icon',
              displayValue: ({ part }) => {
                if (part.status === 'ordered') {
                  return OrderedSVG({})
                }
                if (part.status === 'pending') {
                  return WaitingSVG({})
                }
                return DeliveredSVG({})
              }
            },
            {
              wrapper: GenericWrapper,
              elements: [
                {
                  component: SecondaryTextSm,
                  name: 'Label',
                  displayValue: ({ part, isMobile }) => part.name ? textEllipsis(part.name, isMobile ? 15 : 20) : ''
                },
                {
                  component: SecondaryTextXs300,
                  name: 'Value',
                  displayValue: ({ part }) => {
                    let text = part?.status === 'pending' ? 'Waiting on parts' : part?.status === 'ordered' ? 'Orderd' : 'Delivered';
                    let time = part?.updated_at ? `${formatDistance(0, differenceInSeconds(part.updated_at, today()) * 1000, { includeSeconds: true })} ago` : ''
                    return `${text} ${time} `
                  }
                },
              ]
            }
          ]
        },
        {
          component: wrap(wrap(wrap(SolidButton, SpanWrapper), WhiteSpaceNoWrap), Mr2),
          name: 'Button',
          renderIf: ({ part }) => part?.status !== 'delivered',
          bindings: ({ part, isMobile }) => {
            let title = part?.status === 'pending' ? 'Mark as Ordered' : 'Mark as Delivered';
            if (isMobile) {
              title = part?.status === 'pending' ? 'Ordered' : 'Delivered';
            }
            return { title }
          }
        },
        {
          component: Popup,
          name: 'Popup',
          renderIf: ({ part }) => part?.name?.length > 20,
          displayValue: ({ part }) => part?.name ?? ''
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);